import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { DialogService } from '../../../dialog/dialog.service';
import { BannerCanvasTypesEnum } from '../../../features-data/features-data.data';
import { Toggles } from '../../../features-data/sub-models/toggles.model';

@Component({
  selector: 'app-convert-to-invoice-action',
  templateUrl: 'convert-to-invoice-action.component.html',
  styleUrls: ['convert-to-invoice-action.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConvertToInvoiceComponent implements OnInit, OnChanges, OnDestroy {
  @Input() featureToggles: Toggles;
  @Input() documentFeatureName: string;
  @Input() disableConvertAction: boolean;

  @Output() onConvertToInvoice: EventEmitter<void> = new EventEmitter<void>();

  private _featureName: string;

  convertPermission: boolean;
  readOnlyAccess: boolean;

  constructor(private _dialogService: DialogService) {}

  ngOnChanges(changes: SimpleChanges) {
    this._featureName = Toggles.KEYS.CONVERT_ESTIMATE_TO_INVOICE;

    if (changes.featureToggles && this.featureToggles) {
      this.convertPermission = this.featureToggles.isAllAccess(
        this._featureName
      );
      this.readOnlyAccess = this.featureToggles.isReadOnlyAccess(
        this._featureName
      );
    }
  }

  ngOnInit() {}

  convertToInvoice() {
    if (this.convertPermission) {
      this.onConvertToInvoice.emit();
    } else if (this.featureToggles.isNoAccess(this._featureName)) {
      this._dialogService.openGrowthDialog(
        BannerCanvasTypesEnum.feature_lock,
        this._featureName
      );
    } else if (!this.featureToggles.isAllAccess(this.documentFeatureName)) {
      this._dialogService.openGrowthDialog(
        BannerCanvasTypesEnum.feature_lock,
        this.documentFeatureName
      );
    }
  }

  ngOnDestroy() {
    this._dialogService.closeGrowthDialog(
      BannerCanvasTypesEnum.feature_lock,
      this._featureName
    );
    this._dialogService.closeGrowthDialog(
      BannerCanvasTypesEnum.feature_lock,
      this.documentFeatureName
    );
  }
}
